module.exports = __webpack_public_path__ + "img/value-6.e00005d6.png";